var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":_vm.height,"trigger":_vm.trigger}},_vm._l((_vm.value),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"img",attrs:{"src":item.imgUrl,"alt":""},on:{"click":function($event){return _vm.change(item)}}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }